import { get } from 'lodash';
import { findWithUUID } from '@/utils/uuidHelper';
import withDraft from '@/utils/draftHelper';
import actions from '@/roles/constants';
import { assignValue } from '@/utils/resultsHelper';
import { userCategories } from '../constants';
import { findAllUsers } from './state';

const updateUsersRoleSuccess = withDraft((draft, { items, role }) => {
  findAllUsers(draft, { items }).forEach((category) => {
    items.forEach(({ uuid }) => {
      const userInCategory = findWithUUID(draft.users[category].results, uuid);
      if (userInCategory) {
        userInCategory.role = role;
      }
    });
  });
});

const updateRoleName = withDraft((draft, { code, result: { name } }) => {
  userCategories.forEach((category) => {
    const users = draft.users[category].results.filter((r) => (get(r, 'role.code') === code));
    users.forEach(({ role }) => { assignValue(role, 'name', name); });
  });
});

export default {
  [actions.EDIT_ROLE_SUCCESS]: updateRoleName,
  [actions.UPDATE_USERS_ROLE_SUCCESS]: updateUsersRoleSuccess,
};
